/* tslint:disable */
/* eslint-disable */
/**
 * Notifications API
 * An API to create and read notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: DevTeamProduct@digitalrealty.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime.js';
import type { Notification } from './Notification.js';
import {
    NotificationFromJSON,
    NotificationFromJSONTyped,
    NotificationToJSON,
} from './Notification.js';

/**
 * 
 * @export
 * @interface GetNotifications200Response
 */
export interface GetNotifications200Response {
    /**
     * Pagination link|cursor pointing to the current page.
     * @type {string}
     * @memberof GetNotifications200Response
     */
    self?: string;
    /**
     * Pagination link|cursor pointing to the first page.
     * @type {string}
     * @memberof GetNotifications200Response
     */
    first?: string;
    /**
     * Pagination link|cursor pointing to the previous page.
     * @type {string}
     * @memberof GetNotifications200Response
     */
    prev?: string;
    /**
     * Pagination link|cursor pointing to the next page.
     * @type {string}
     * @memberof GetNotifications200Response
     */
    next?: string;
    /**
     * Pagination link|cursor pointing to the last page.
     * @type {string}
     * @memberof GetNotifications200Response
     */
    last?: string;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof GetNotifications200Response
     */
    items: Array<Notification>;
}

/**
 * Check if a given object implements the GetNotifications200Response interface.
 */
export function instanceOfGetNotifications200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function GetNotifications200ResponseFromJSON(json: any): GetNotifications200Response {
    return GetNotifications200ResponseFromJSONTyped(json, false);
}

export function GetNotifications200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNotifications200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'self': !exists(json, 'self') ? undefined : json['self'],
        'first': !exists(json, 'first') ? undefined : json['first'],
        'prev': !exists(json, 'prev') ? undefined : json['prev'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'items': ((json['items'] as Array<any>).map(NotificationFromJSON)),
    };
}

export function GetNotifications200ResponseToJSON(value?: GetNotifications200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'self': value.self,
        'first': value.first,
        'prev': value.prev,
        'next': value.next,
        'last': value.last,
        'items': ((value.items as Array<any>).map(NotificationToJSON)),
    };
}

